// test1751
(1751 && 0);
